import constants from '../constants'


const grayStatuses = [
  constants.deliveryStates.damaged,
  constants.deliveryStates.returned,
  constants.deliveryStates.wrongItem,
  constants.deliveryStates.notAvailable,
  constants.deliveryStates.deliveryIssue,
  constants.deliveryStates.incompleteOrder,
]
  .map((status) => status.toLowerCase())


const getTrackingStatusColor = (status = '') => {
  const lowerCasedStatus = status.toLowerCase()

  if (!status || grayStatuses.includes(lowerCasedStatus)) {
    return 'gray-80'
  }

  const isDelivered = lowerCasedStatus === constants.deliveryStates.delivered.toLowerCase()

  if (isDelivered) {
    return 'success'
  }

  return 'brand'
}


export default getTrackingStatusColor
